import { Component } from '@angular/core';

import { PrimeNG } from 'primeng/config';

import { RouterOutlet } from '@angular/router';

import translations from '../translations/es-CO.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet],
})
export class AppComponent {
  public topbarTheme: string = 'light';
  public menuTheme: string = 'dim';
  public layoutMode: string = 'light';
  public menuMode: string = 'static';
  public isRTL: boolean = false;
  public inputStyle: string = 'outlined';
  public ripple: boolean = true;
  public title: string = 'soch';

  constructor(private readonly primeng: PrimeNG) {
    this.primeng.ripple.set(this.ripple);
    this.primeng.setTranslation(translations);
  }
}
